import React, { useState, lazy } from 'react';
import { Link } from 'react-router-dom';
import { AnimatedSection } from '../shared/AnimatedSection';
import { Sign } from '../../data/signs';
import { motion } from 'framer-motion';
import { startCheckout } from '../../lib/metaPixel';
import { UpsellPopup } from '../shared/UpsellPopup';
import { CompletaUpsellPopup } from '../shared/CompletaUpsellPopup';
import { SecretPortalReveal } from '../shared/SecretPortalReveal';
interface SignProductosProps {
  sign: Sign;
}
const PRODUCTOS_BG = 'https://cdn.shopify.com/s/files/1/0661/3847/2542/files/mm8DHXzU7JhvCgYay4N1kmyc5Q2WN4pg9GNtp0heMg7BSrM3QpCC0xGOYBCXzy5-GOp2Z8fowqxSWnS4ldgA120xXC67zpfx2qL_wjuAepxGwDo6ErItRpus49bMEA7U.jpg?v=1778629864';
/**
 * Checkout URL for the full 12-Reinos system access.
 * TODO: replace this placeholder with the real Shopify variant checkout URL
 * when the bundle product is created.
 */
const SISTEMA_CHECKOUT_URL = 'https://los12reinos.com/cart/42780064645214:1';
// ── Sigils (used as visual anchors for the Experiencia Completa items) ──
const SigilCore = ({
  color
}: {
  color: string;
}) => <svg width="36" height="36" viewBox="0 0 44 44" fill="none" data-id="element-980">
    <circle cx="22" cy="22" r="20" stroke={color} strokeWidth="0.8" opacity="0.6" data-id="element-981" />
    <circle cx="22" cy="22" r="12" stroke={color} strokeWidth="0.6" strokeDasharray="2 3" opacity="0.7" data-id="element-982" />
    <circle cx="22" cy="22" r="4" fill={color} data-id="element-983" />
  </svg>;
const SigilShadow = ({
  color
}: {
  color: string;
}) => <svg width="36" height="36" viewBox="0 0 44 44" fill="none" data-id="element-984">
    <circle cx="22" cy="22" r="20" stroke={color} strokeWidth="0.8" opacity="0.6" data-id="element-985" />
    <path d="M22 6 L30 22 L22 38 L14 22 Z" stroke={color} strokeWidth="1" fill={color} fillOpacity="0.15" data-id="element-986" />
    <circle cx="22" cy="22" r="4" fill={color} data-id="element-987" />
  </svg>;
const SigilRitual = ({
  color
}: {
  color: string;
}) => <svg width="36" height="36" viewBox="0 0 44 44" fill="none" data-id="element-988">
    <circle cx="22" cy="22" r="20" stroke={color} strokeWidth="0.8" opacity="0.6" data-id="element-989" />
    <circle cx="22" cy="22" r="10" fill={color} fillOpacity="0.15" data-id="element-990" />
    <path d="M14 22 A8 8 0 0 1 30 22" stroke={color} strokeWidth="1.2" fill="none" data-id="element-991" />
    <circle cx="14" cy="22" r="1.5" fill={color} data-id="element-992" />
    <circle cx="30" cy="22" r="1.5" fill={color} data-id="element-993" />
  </svg>;
const SigilCamara = ({
  color
}: {
  color: string;
}) => <svg width="36" height="36" viewBox="0 0 44 44" fill="none" data-id="element-994">
    <circle cx="22" cy="22" r="20" stroke={color} strokeWidth="0.8" opacity="0.6" data-id="element-995" />
    {[0, 72, 144, 216, 288].map(a => <line key={a} x1="22" y1="22" x2="22" y2="6" stroke={color} strokeWidth="0.7" opacity="0.7" transform={`rotate(${a} 22 22)`} data-id="element-996" />)}
    <circle cx="22" cy="22" r="3" fill={color} data-id="element-997" />
  </svg>;
const SigilCompat = ({
  color
}: {
  color: string;
}) => <svg width="36" height="36" viewBox="0 0 44 44" fill="none" data-id="element-998">
    <circle cx="14" cy="22" r="10" stroke={color} strokeWidth="0.8" opacity="0.7" data-id="element-999" />
    <circle cx="30" cy="22" r="10" stroke={color} strokeWidth="0.8" opacity="0.7" data-id="element-1000" />
    <circle cx="22" cy="22" r="2.5" fill={color} data-id="element-1001" />
  </svg>;
const SigilSistema = ({
  color
}: {
  color: string;
}) => <svg width="44" height="44" viewBox="0 0 44 44" fill="none" data-id="element-1002">
    <circle cx="22" cy="22" r="20" stroke={color} strokeWidth="0.8" opacity="0.6" data-id="element-1003" />
    {Array.from({
    length: 12
  }).map((_, i) => <line key={i} x1="22" y1="4" x2="22" y2="8" stroke={color} strokeWidth="0.9" transform={`rotate(${i * 30} 22 22)`} data-id="element-1004" />)}
    <circle cx="22" cy="22" r="10" stroke={color} strokeWidth="0.6" strokeDasharray="2 3" opacity="0.7" data-id="element-1005" />
    <circle cx="22" cy="22" r="3" fill={color} data-id="element-1006" />
  </svg>;
export function SignProductos({
  sign
}: SignProductosProps) {
  return <section id="sign-offers" className="relative py-24 md:py-32 px-4 md:px-6 overflow-hidden" data-id="element-1007">
      {/* Background image tinted with sign color */}
      <div className="absolute inset-0 z-0" data-id="element-1008">
        <img src={PRODUCTOS_BG} alt="" aria-hidden="true" className="w-full h-full object-cover" loading="lazy" data-id="element-1009" />
        <div className="absolute inset-0 bg-cosmic-black/82" data-id="element-1010" />
        <div className="absolute inset-0" style={{
        backgroundColor: sign.colors.primary,
        opacity: 0.18
      }} data-id="element-1011" />
        <div className="absolute inset-0" style={{
        background: `linear-gradient(180deg, #050508 0%, ${sign.colors.primary}10 50%, #050508 100%)`
      }} data-id="element-1012" />
      </div>

      <div className="relative z-10 container mx-auto max-w-6xl" data-id="element-1013">
        <AnimatedSection data-id="element-1014">
          <div className="text-center mb-16 md:mb-20 px-2" data-id="element-1015">
            <motion.div className="inline-flex items-center gap-3 mb-6" initial={{
            opacity: 0
          }} whileInView={{
            opacity: 1
          }} viewport={{
            once: true
          }} data-id="element-1016">
              <div className="h-px w-10 md:w-12" style={{
              background: `linear-gradient(90deg, transparent, ${sign.colors.primary})`
            }} data-id="element-1017" />
              <span className="md:text-[11px] tracking-[0.35em] uppercase font-serif text-[14px]" style={{
              color: sign.colors.accent
            }} data-id="element-1018">
                Accesos al Reino
              </span>
              <div className="h-px w-10 md:w-12" style={{
              background: `linear-gradient(90deg, ${sign.colors.primary}, transparent)`
            }} data-id="element-1019" />
            </motion.div>

            <h2 className="text-4xl md:text-5xl font-serif font-bold text-white mb-6 leading-tight" data-id="element-1020">
              Elige cómo quieres entrar a LOS 12
            </h2>
            <p className="max-w-2xl mx-auto text-lg md:text-xl font-serif italic leading-relaxed" style={{
            color: `${sign.colors.accent}E0`
          }} data-id="element-1021">
              Tu puerta de entrada a un Reino, o al universo completo de LOS 12.
            </p>
            <p className="max-w-2xl mx-auto mt-4 text-base md:text-lg italic leading-relaxed font-['DM_Sans',_sans-serif]" style={{
            color: `${sign.colors.accent}B5`
          }} data-id="element-1022">
              Accede a las 12 experiencias inmersivas y todos los documentos
              exclusivos del sistema LOS 12.
            </p>
          </div>
        </AnimatedSection>

        {/* ─── Tier 2 — Experiencia Recomendada · $24.99 ──────────── */}
        <AnimatedSection delay={0.22} data-id="element-1023">
          <div className="mb-12 md:mb-16" data-id="element-1024">
            <ExperienciaCompleta sign={sign} data-id="element-1025" />
          </div>
        </AnimatedSection>

        {/* ─── Tier 3 — Secret Portal Reveal ($89.88) ──────────────── */}
        <AnimatedSection delay={0.3} data-id="element-1026">
          <SecretPortalReveal signName={sign.name} checkoutUrl={SISTEMA_CHECKOUT_URL} primaryColor={sign.colors.primary} accentColor={sign.colors.accent} data-id="element-1027" />
        </AnimatedSection>
      </div>
    </section>;
}
// ═════════════════════════════════════════════════════════════════════════
// TIER 1 — Acceso Esencial · "El Núcleo de tu Reino" · $12.69
// Minimal, elegant entry-point card.
// ═════════════════════════════════════════════════════════════════════════
function AccesoEsencial({
  sign,
  onUpsell
}: {
  sign: Sign;
  onUpsell: () => void;
}) {
  const PRICE = 12.69;
  return <motion.div className="relative border rounded-2xl p-8 md:p-12 text-center overflow-hidden max-w-2xl mx-auto" style={{
    borderColor: `${sign.colors.primary}55`,
    background: `linear-gradient(145deg, rgba(0,0,0,0.98) 0%, rgba(8,8,12,0.96) 55%, ${sign.colors.primary}08 100%)`,
    boxShadow: `0 0 24px ${sign.colors.primary}18, inset 0 0 18px ${sign.colors.primary}06`
  }} whileHover={{
    y: -2
  }} transition={{
    type: 'spring',
    stiffness: 200,
    damping: 22
  }} data-id="element-1028">
      {/* Subtle ambient pulse */}
      <motion.div className="absolute inset-0 rounded-2xl pointer-events-none" animate={{
      boxShadow: [`inset 0 0 22px ${sign.colors.primary}10`, `inset 0 0 45px ${sign.colors.primary}22`, `inset 0 0 22px ${sign.colors.primary}10`]
    }} transition={{
      duration: 5,
      repeat: Infinity,
      ease: 'easeInOut'
    }} data-id="element-1029" />

      <div className="relative" data-id="element-1030">
        <p className="tracking-[0.35em] uppercase font-serif mb-3 opacity-80 text-[14px]" style={{
        color: sign.colors.accent
      }} data-id="element-1031">
          Acceso Esencial
        </p>

        <div className="flex justify-center mb-5" style={{
        color: sign.colors.primary
      }} data-id="element-1032">
          <SigilCore color={sign.colors.primary} data-id="element-1033" />
        </div>

        <h3 className="text-3xl md:text-4xl font-serif font-bold mb-4" style={{
        color: '#F5F0E1',
        textShadow: `0 0 18px ${sign.colors.primary}50`
      }} data-id="element-1034">
          El Núcleo de tu Reino
        </h3>

        <p className="text-base md:text-lg text-gray-200 leading-relaxed mb-8 max-w-md mx-auto font-serif" data-id="element-1035">
          La puerta de entrada al sistema. El libro principal que revela tu
          patrón dominante, tu identidad emocional central y la estructura
          interna desde la que vives sin saberlo.
        </p>

        <p className="text-5xl md:text-6xl font-bold mb-8 font-serif" style={{
        color: sign.colors.primary,
        textShadow: `0 0 20px ${sign.colors.primary}80`
      }} data-id="element-1036">
          ${PRICE}
        </p>

        <motion.button onClick={onUpsell} className="inline-block w-full sm:w-auto px-10 py-5 font-bold rounded-xl transition-colors text-lg tracking-wide" style={{
        backgroundColor: sign.colors.primary,
        color: '#050508'
      }} whileHover={{
        scale: 1.03,
        boxShadow: `0 0 40px ${sign.colors.primary}90`
      }} whileTap={{
        scale: 0.97
      }} data-id="element-1037">
          Descubre Mi Reino
        </motion.button>

        {/* Tier 1 exclusions — clarifies what is NOT included at $12.69.
            Wrapped in a dark blurred panel so the copy stays legible over
            bright/gold backgrounds in mobile. */}
        <div className="mt-6 inline-flex flex-col items-center gap-1.5 px-5 py-2.5 rounded-xl backdrop-blur-md" style={{}} data-id="element-1038">
          <p className="text-[11px] md:text-xs font-serif tracking-[0.25em] uppercase font-semibold" style={{
          color: '#E8D48B',
          textShadow: '0 1px 6px rgba(0,0,0,0.8)'
        }} data-id="element-1039">
            NO INCLUYE PORTAL DE USUARIO
          </p>
          <p className="text-[11px] md:text-xs font-serif tracking-[0.25em] uppercase font-semibold" style={{
          color: '#E8D48B',
          textShadow: '0 1px 6px rgba(0,0,0,0.8)'
        }} data-id="element-1040">
            NO INCLUYE EXPERIENCIA INMERSIVA
          </p>
        </div>
      </div>
    </motion.div>;
}
// ═════════════════════════════════════════════════════════════════════════
// TIER 2 — Experiencia Recomendada · "Desbloqueo Total del Reino" · $24.99
// ═════════════════════════════════════════════════════════════════════════
function ExperienciaCompleta({
  sign
}: {
  sign: Sign;
}) {
  const PRICE = 24.99;
  const ORIGINAL = 54.95;
  const items = [{
    sigil: <SigilCore color={sign.colors.primary} data-id="element-1041" />,
    title: '📘 Documento Principal - Núcleo del Arquetipo',
    desc: 'Descubre la estructura emocional que dirige tu forma de sentir, reaccionar y decidir.'
  }, {
    sigil: <SigilShadow color={sign.colors.primary} data-id="element-1042" />,
    title: '📘 Experiencia Privada de Lectura - Archivo Sombrío',
    desc: 'Explora los patrones ocultos y emociones repetitivas que siguen influyendo en tus relaciones y decisiones.'
  }, {
    sigil: <SigilRitual color={sign.colors.primary} data-id="element-1043" />,
    title: '📘 Guía de Transformación Interna - Ritual del Eclipse',
    desc: 'Una experiencia diseñada para ayudarte a observar y romper ciclos emocionales inconscientes.'
  }, {
    sigil: <SigilCompat color={sign.colors.primary} data-id="element-1044" />,
    title: '📘 Documento de Vínculos y Patrones - Códice de Compatibilidad',
    desc: 'Comprende por qué atraes ciertos tipos de personas y dinámicas emocionales repetitivas.'
  }];
  return <motion.div className="relative border rounded-2xl px-10 md:px-16 py-8 md:py-12 text-center overflow-hidden max-w-6xl mx-auto" style={{
    borderColor: `${sign.colors.primary}55`,
    background: `linear-gradient(145deg, rgba(0,0,0,0.98) 0%, rgba(8,8,12,0.96) 55%, ${sign.colors.primary}08 100%)`,
    boxShadow: `0 0 24px ${sign.colors.primary}18, inset 0 0 18px ${sign.colors.primary}06`
  }} whileHover={{
    y: -3
  }} transition={{
    type: 'spring',
    stiffness: 200,
    damping: 22
  }} data-id="element-1045">
      <motion.div className="absolute inset-0 rounded-2xl pointer-events-none" animate={{
      boxShadow: [`inset 0 0 22px ${sign.colors.accent}12`, `inset 0 0 48px ${sign.colors.accent}26`, `inset 0 0 22px ${sign.colors.accent}12`]
    }} transition={{
      duration: 5,
      repeat: Infinity,
      ease: 'easeInOut'
    }} data-id="element-1046" />

      <div className="relative" data-id="element-1047">
        {/* Recommended badge */}
        <div className="inline-flex items-center gap-2 px-3.5 py-2 rounded-full mb-5" style={{
        background: 'rgba(0,0,0,0.92)',
        color: '#F5F0E1',
        border: `1px solid ${sign.colors.accent}88`,
        boxShadow: `
    0 0 14px ${sign.colors.accent}90,
    0 0 34px ${sign.colors.accent}70,
    0 0 70px ${sign.colors.accent}40,
    inset 0 0 14px ${sign.colors.accent}22,
    inset 0 0 20px rgba(255,255,255,0.04)
  `,
        backdropFilter: 'blur(14px)',
        WebkitBackdropFilter: 'blur(14px)'
      }} data-id="element-1048">
          <span className="text-[11px] md:text-[12px] tracking-[0.25em] sm:tracking-[0.3em] uppercase font-serif font-bold text-[#FFCF31]" data-id="element-1049">
            Experiencia Recomendada
          </span>
        </div>

        <p className="text-[11px] md:text-[12px] tracking-[0.3em] sm:tracking-[0.35em] uppercase font-serif mb-3 opacity-80" style={{
        color: sign.colors.accent
      }} data-id="element-1050">
          Experiencia Completa · $24.99
        </p>

        <h3 className="text-3xl md:text-4xl lg:text-5xl font-serif font-bold mb-4 leading-tight" style={{
        color: '#F5F0E1',
        textShadow: `0 0 22px ${sign.colors.accent}60`
      }} data-id="element-1051">
          Desbloqueo Total del Reino
        </h3>

        <p className="text-base md:text-lg text-gray-200 leading-relaxed mb-8 max-w-xl mx-auto font-serif italic" data-id="element-1052">
          Accede a todas las capas emocionales y psicológicas de tu Reino.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-5 mb-6 max-w-2xl mx-auto text-left" data-id="element-1053">
          {items.map(item => <div key={item.title} className="flex items-start gap-3 p-4 rounded-xl" style={{
          background: 'linear-gradient(135deg, rgba(12,12,20,0.7) 0%, rgba(8,8,14,0.65) 100%)',
          border: `1px solid ${sign.colors.accent}1F`
        }} data-id="element-1054">
              <div className="flex-shrink-0" data-id="element-1055">{item.sigil}</div>
              <div className="min-w-0" data-id="element-1056">
                <p className="text-[15px] md:text-base font-serif font-semibold mb-1" style={{
              color: '#F5F0E1'
            }} data-id="element-1057">
                  {item.title}
                </p>
                <p className="text-[13px] md:text-sm italic leading-snug font-['DM_Sans',_sans-serif]" style={{
              color: `${sign.colors.accent}C0`
            }} data-id="element-1058">
                  {item.desc}
                </p>
              </div>
            </div>)}
        </div>

        {/* Cámara Astral · Portal de Usuario — centered hero block */}
        <motion.div className="relative max-w-2xl mx-auto mb-10 md:mb-12 rounded-2xl px-6 py-8 md:px-10 md:py-12 text-center overflow-hidden" style={{
        background: '#000000',
        border: `1px solid ${sign.colors.primary}`
      }} initial={{
        opacity: 0,
        y: 8
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-40px'
      }} transition={{
        duration: 0.7,
        ease: [0.16, 1, 0.3, 1]
      }} data-id="element-1059">
          {/* Animated illuminated frame — pulses in sign color */}
          <motion.div className="absolute inset-0 rounded-2xl pointer-events-none" animate={{
          boxShadow: [`0 0 18px ${sign.colors.primary}80, 0 0 36px ${sign.colors.accent}40, inset 0 0 18px ${sign.colors.primary}30`, `0 0 38px ${sign.colors.primary}, 0 0 70px ${sign.colors.accent}70, inset 0 0 32px ${sign.colors.primary}55`, `0 0 18px ${sign.colors.primary}80, 0 0 36px ${sign.colors.accent}40, inset 0 0 18px ${sign.colors.primary}30`]
        }} transition={{
          duration: 4.5,
          repeat: Infinity,
          ease: 'easeInOut'
        }} data-id="element-1060" />

          {/* Moving diffused color orbs — sign-tinted blur in motion */}
          <motion.div className="absolute pointer-events-none rounded-full" style={{
          width: 280,
          height: 280,
          background: `radial-gradient(circle, ${sign.colors.primary}55 0%, transparent 70%)`,
          filter: 'blur(50px)',
          top: '10%',
          left: '15%'
        }} animate={{
          x: [0, 80, -40, 0],
          y: [0, 50, -30, 0],
          scale: [1, 1.15, 0.9, 1]
        }} transition={{
          duration: 12,
          repeat: Infinity,
          ease: 'easeInOut'
        }} data-id="element-1061" />
          <motion.div className="absolute pointer-events-none rounded-full" style={{
          width: 240,
          height: 240,
          background: `radial-gradient(circle, ${sign.colors.accent}50 0%, transparent 70%)`,
          filter: 'blur(55px)',
          bottom: '5%',
          right: '10%'
        }} animate={{
          x: [0, -60, 40, 0],
          y: [0, -40, 30, 0],
          scale: [1, 0.9, 1.2, 1]
        }} transition={{
          duration: 14,
          repeat: Infinity,
          ease: 'easeInOut',
          delay: 1.5
        }} data-id="element-1062" />
          <motion.div className="absolute pointer-events-none rounded-full" style={{
          width: 200,
          height: 200,
          background: `radial-gradient(circle, ${sign.colors.primary}45 0%, transparent 70%)`,
          filter: 'blur(45px)',
          top: '40%',
          right: '25%'
        }} animate={{
          x: [0, 50, -50, 0],
          y: [0, -60, 40, 0],
          scale: [1, 1.1, 0.95, 1]
        }} transition={{
          duration: 10,
          repeat: Infinity,
          ease: 'easeInOut',
          delay: 3
        }} data-id="element-1063" />

          {/* Soft top halo — sign tinted */}
          <div className="absolute top-0 left-1/2 -translate-x-1/2 pointer-events-none" style={{
          width: '120%',
          height: 180,
          background: `radial-gradient(ellipse at top, ${sign.colors.accent}40 0%, transparent 65%)`,
          filter: 'blur(18px)'
        }} data-id="element-1064" />

          <div className="relative" data-id="element-1065">
            <p className="text-[11px] md:text-[12px] tracking-[0.35em] sm:tracking-[0.45em] uppercase font-serif font-semibold mb-5" style={{
            color: sign.colors.accent,
            textShadow: `0 0 10px ${sign.colors.primary}70`
          }} data-id="element-1066">
              Acceso Exclusivo · Portal del Reino
            </p>

            <div className="flex justify-center mb-5" style={{
            transform: 'scale(1.6)',
            transformOrigin: 'center'
          }} data-id="element-1067">
              <SigilCamara color={sign.colors.accent} data-id="element-1068" />
            </div>

            <h4 className="text-[28px] md:text-[36px] lg:text-[42px] font-serif font-bold mb-4 leading-tight" style={{
            color: '#F5F0E1',
            textShadow: `0 0 18px ${sign.colors.primary}90, 0 2px 14px rgba(0,0,0,0.6)`
          }} data-id="element-1069">
              Cámara Astral
            </h4>

            <p className="text-[14px] md:text-[16px] lg:text-[17px] font-serif italic leading-relaxed mb-5 max-w-md mx-auto" style={{
            color: 'rgba(245,240,225,0.92)'
          }} data-id="element-1070">
              Tu espacio privado dentro del Reino. Accede a todos los
              documentos, archivos desbloqueados y experiencias relacionadas con
              tu energía.
            </p>

            <p className="text-[11.5px] md:text-[13px] tracking-[0.3em] sm:tracking-[0.4em] uppercase font-serif font-semibold" style={{
            color: sign.colors.accent,
            textShadow: `0 0 10px ${sign.colors.primary}70`
          }} data-id="element-1071">
              — Portal de Usuario —
            </p>
          </div>
        </motion.div>

        <div className="flex items-baseline justify-center gap-3 mb-8" data-id="element-1072">
          <span className="text-2xl md:text-3xl font-serif line-through" style={{
          color: `${sign.colors.accent}60`
        }} data-id="element-1073">
            ${ORIGINAL}
          </span>
          <span className="text-5xl md:text-6xl font-bold font-serif" style={{
          color: sign.colors.accent,
          textShadow: `0 0 22px ${sign.colors.accent}A0`
        }} data-id="element-1074">
            ${PRICE}
          </span>
        </div>

        <motion.button onClick={() => startCheckout(sign.name, sign.checkoutUrlCompleta, PRICE)} className="w-full sm:w-auto inline-block px-10 md:px-12 py-5 md:py-6 font-bold rounded-xl text-base md:text-lg tracking-[0.15em]" style={{
        background: `linear-gradient(135deg, ${sign.colors.primary} 0%, ${sign.colors.accent} 100%)`,
        color: '#050508',
        boxShadow: `0 0 32px ${sign.colors.accent}90`
      }} whileHover={{
        scale: 1.03,
        boxShadow: `0 0 50px ${sign.colors.accent}`
      }} whileTap={{
        scale: 0.97
      }} data-id="element-1075">
          DESBLOQUEAR MI REINO COMPLETO
        </motion.button>

        <p className="mt-6 mb-3 font-serif font-semibold tracking-[0.18em] text-[15px] md:text-base" style={{
        color: sign.colors.accent,
        textShadow: `0 0 14px ${sign.colors.accent}70`
      }} data-id="element-1076">
          Vive una Experiencia Inmersiva
        </p>

        <p className="max-w-xl mx-auto text-[13.5px] md:text-sm italic leading-relaxed px-4 font-['DM_Sans',_sans-serif]" style={{
        color: `${sign.colors.accent}C8`
      }} data-id="element-1077">
          Después de tu compra recibirás un acceso exclusivo a tu Portal del
          Reino. Todos tus archivos y experiencias estarán disponibles dentro de
          tu espacio privado, diseñado para explorar tu universo de forma
          inmersiva.
        </p>
      </div>
    </motion.div>;
}